/**
 * Concatenated-time helpers for multi-part pandora items.
 *
 * A pandora item can be split into several parts; a clip's `part` + source-local
 * media time must be mapped to CONCATENATED item time (the sum of prior part
 * durations + local time) to address frames / timeline strips. This module is
 * the non-React home of that mapping so both the timeline UI (`usePartOffsets`)
 * and the preview engine can share one promise cache.
 */
import { getItem } from '../api/pandora';
import { partOffsetsFromDurations } from '../format/textInsert';

export { partOffsetsFromDurations };

/** Concatenated item time for a source-local media time within a 1-based part. */
export function concatTime(offsets: number[], part: number, mediaTime: number): number {
  const offset = offsets[part - 1] ?? 0;
  return offset + mediaTime;
}

const cache = new Map<string, Promise<number[]>>();

/** Load (once) the part offsets for a pandora item, keyed by `site/item`. */
export function getPartOffsets(site: string, item: string): Promise<number[]> {
  const key = `${site}/${item}`;
  let promise = cache.get(key);
  if (!promise) {
    promise = getItem(site, item).then((it) => partOffsetsFromDurations(it.durations ?? []));
    cache.set(key, promise);
  }
  return promise;
}

/** Test hook. */
export function __clearPartOffsetCache(): void {
  cache.clear();
}
